import { trackEvent } from 'dibs-tracking';

function _trackEvent({
    action,
    label,
    noninteraction = 0,
}: {
    action: string;
    label: string;
    noninteraction?: number;
}): void {
    trackEvent({
        event: 'e_ga_event',
        category: 'NFT',
        action,
        label,
        noninteraction,
    });
}

export function entry(action: string, label: string): void {
    _trackEvent({ action, label });
}

export function sellConfirm(label: string): void {
    _trackEvent({
        action: 'NFT sell interaction - confirm sell',
        label,
    });
}

export function sellComplete(label: string): void {
    _trackEvent({
        action: 'NFT sell complete',
        label,
        noninteraction: 1,
    });
}

export function cancelConfirm(label: string): void {
    _trackEvent({
        action: 'NFT auction cancel interaction - confirm cancel',
        label,
    });
}

export function cancelComplete(label: string): void {
    _trackEvent({
        action: 'NFT auction cancel complete',
        label,
        noninteraction: 1,
    });
}

export function error(label: string): void {
    _trackEvent({
        action: 'sell error displayed',
        label,
    });
}
